import {
  Cloud, MapPin, PhoneForwarded, Smartphone, ArrowLeftRight, Globe, Network, Headphones, ShieldCheck, Laptop, UsersRound,
} from 'lucide-react';

export const products = [
  {
    slug: 'cloud-pbx',
    crystal: '/media/icons/cloud-pbx.webp',
    icon: Cloud,
    group: 'phone-system',
    to: '/products/cloud-pbx',
    title: 'Cloud PBX',
    subtitle: 'Business phone system',
    description: 'A complete business phone system in the cloud. Call routing, IVR, queues and desktop and mobile apps without on-site hardware.',
  },
  {
    slug: 'did-international',
    crystal: '/media/icons/did-international.webp',
    icon: MapPin,
    group: 'numbers',
    to: '/phone-numbers/did-international',
    title: 'DID International Numbers',
    subtitle: 'Local presence in 140+ countries',
    description: 'Local and national numbers worldwide, routed to your PBX, SIP trunk or mobile.',
  },
  {
    slug: 'toll-free',
    crystal: '/media/icons/toll-free.webp',
    icon: PhoneForwarded,
    group: 'numbers',
    to: '/phone-numbers/toll-free',
    title: 'Toll-Free Numbers',
    subtitle: 'Freephone / ITFS numbers',
    description: 'Free-to-call numbers that make it easy for customers to reach you.',
  },
  {
    slug: 'mobile',
    crystal: '/media/icons/mobile.webp',
    icon: Smartphone,
    group: 'numbers',
    to: '/phone-numbers/mobile',
    title: 'Mobile Numbers',
    subtitle: 'Voice & SMS enabled',
    description: 'Mobile ranges for voice and SMS, ready for apps and field teams.',
  },
  {
    slug: '2way',
    crystal: '/media/icons/2way.webp',
    icon: ArrowLeftRight,
    group: 'numbers',
    to: '/phone-numbers/2way',
    title: '2-Way Numbers',
    subtitle: 'Inbound and outbound on one number',
    description: 'Call out and receive calls on the same number, so customers always see a number they can call back.',
  },
  {
    slug: 'uifn',
    crystal: '/media/icons/uifn.webp',
    icon: Globe,
    group: 'numbers',
    to: '/phone-numbers/uifn',
    title: 'UIFN Numbers',
    subtitle: 'Universal International Freephone',
    description: 'One freephone number that callers can dial from multiple countries.',
  },
  {
    slug: 'sip-trunking',
    crystal: '/media/icons/sip-trunking.webp',
    icon: Network,
    group: 'connectivity',
    to: '/products/sip-trunking',
    title: 'SIP Trunking',
    subtitle: 'Carrier-grade voice connectivity',
    description: 'Connect your PBX or platform to the public network over SIP with failover routing.',
  },
  {
    slug: 'ai-receptionist',
    crystal: '/media/icons/ai-receptionist.webp',
    icon: Headphones,
    group: 'phone-system',
    to: '/products/ai-receptionist',
    title: 'AI Receptionist',
    subtitle: 'Answers and routes every call',
    description: 'An AI voice agent that greets callers, answers common questions and puts them through to the right person.',
  },
  {
    slug: 'voice-otp',
    crystal: '/media/icons/voice-otp.webp',
    icon: ShieldCheck,
    group: 'connectivity',
    to: '/products/voice-otp',
    title: 'Voice OTP & Flash Calls',
    subtitle: 'Verification without SMS',
    description: 'Verify users with a missed call whose caller ID is the one-time code. A lower-cost alternative to SMS OTP.',
  },
  {
    slug: 'softphone',
    icon: Laptop,
    group: 'phone-system',
    to: '/products/softphone',
    title: 'Softphone',
    subtitle: 'Calls, video & chat in one app',
    description: 'Use your business number on Windows, macOS, iOS, Android or in the browser.',
    // Listed in the menu and footer; the home page grid keeps its nine cards.
    home: false,
  },
  {
    slug: 'teams-phone',
    icon: UsersRound,
    group: 'phone-system',
    to: '/products/teams-phone-system',
    title: 'Teams Phone System',
    subtitle: 'External calls inside Microsoft Teams',
    description: 'Make and take calls to any number from Microsoft Teams, keep your numbers and add queues and IVRs.',
    home: false,
  },
];

// Menu and footer sections, in display order. Each lists product slugs in the order shown.
export const productGroups = [
  { id: 'phone-system', title: 'Business phone system', slugs: ['cloud-pbx', 'teams-phone', 'softphone', 'ai-receptionist'] },
  { id: 'numbers', title: 'Phone numbers', slugs: ['did-international', 'toll-free', 'mobile', '2way', 'uifn'] },
  { id: 'connectivity', title: 'Connectivity & verification', slugs: ['sip-trunking', 'voice-otp'] },
].map((g) => ({ ...g, items: g.slugs.map((slug) => products.find((p) => p.slug === slug)) }));
